module.exports = __webpack_public_path__ + "static/media/brand-user-add.b6e89985.svg";